import React from "react";
import { Link } from "react-router-dom";

export default function SecureSection() {
  return (
    <section
      className="relative w-full flex items-center justify-center overflow-hidden text-white"
      style={{
        minHeight: "70vh", // ensures image always has height
      }}
    >
      {/* ✅ Parallax Background */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/images/banner3.webp')",
          backgroundAttachment: "fixed",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          zIndex: 0,
        }}
      ></div>


      {/* ✅ Overlay for contrast */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          zIndex: 1,
        }}
      ></div>

      {/* ✅ Foreground content */}
      <div className="relative z-10 text-center px-6 max-w-3xl">
        <h3 className="text-3xl md:text-4xl font-bold mb-4">
          Stop Thinking for Security!
        </h3>
        <p className="text-gray-200 mb-8">
          Security isn’t an afterthought — it’s the foundation of everything we
          build. Our solutions are designed to protect your data and keep your
          business safe without compromise.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/domains"
            className="flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-md transition-all duration-300"
          >
            <i className="fa fa-shopping-cart"></i> BUY IT NOW
          </Link>

          <span className="text-gray-300 font-medium">-or-</span>

          <Link
            to="/contact"
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-md transition-all duration-300"
          >
            <i className="fa fa-comments"></i> Ask Question
          </Link>
        </div>
      </div>
    </section>
  );
}
